<template lang="pug">
  main.instruments(v-if="settings")
    header.header
      main-menu
      carousel(
        :perPage="1"
        :autoplay="true"
        :autoplayHoverPause="true"
        :loop="true"
        :autoplayTimeout="6000"
        paginationColor="#f8f8f8"
        paginationActiveColor="#5477a3"
      )
        slide(
          v-for="(slide, index) in settings.sections.instruments.carousel"
          :key="index"
          :style="`background-image:url(${slide})`"
        )
    section.section
      div.container
        div.description(v-if="instrument" :class="title")
          h1 OUR INSTRUMENTS
          h2.title {{ title }}
          div(v-html="instrument.description")
        div.instrument(v-if="instrument.models")
          div.wrapp-generic(v-for="(generic, index) in instrument.models" :key="`generic${index}`")
            div.generic(:class="{ open: generic.open }")
              div.button(@click="openDetails(generic)")
                div
                  span
                  span
              div.name
                h1 {{ generic.name }}
                div.metadata
                  h3 {{ generic.count_active }}
                    span / Active Now
              div.more
                p(v-html="generic.description || ''")
                div.gallery(v-if="generic.images.length")
                  h4 {{ generic.name }}
                    span  gallery
                  carousel(
                    :perPage="1"
                    :perPageCustom="[[768, 2], [1024, 3]]"
                    :loop="true"
                    paginationColor="#f8f8f8"
                    paginationActiveColor="#5477a3"
                  )
                    slide(
                      v-for="image in generic.images"
                      :key="image.id"
                      @slideClick="openOverlay(image)"
                      :class="{video: image.id_type === 2}"
                    )
                      div(v-if="image.id_type === 1" :style="`background-image:url(${image.url})`")
                      vimeo-player(v-if="image.id_type === 2" :video-id='image.url' @ready="onReadyVideo" player-width="380")
                      p(v-if="image.id_type === 1") {{ image.didascalia }}
                    slide(
                      class="noimg"
                      v-if="generic.images.length < 3"
                    )
                    slide(
                      class="noimg"
                      v-if="generic.images.length === 1"
                    )
                div.model-wrapper(v-if="generic.instruments.length")
                  div.model(v-for="model in generic.instruments" :key="model.id_type")
                    div.metadata(v-if="model.count_active")
                      h3 {{ model.count_active }}
                        span / Active Now
                      a(@click="viewMap(model.id_type)") Vedi la mappa
                    h2 {{ model.name }}
                    p.model--description(v-if="model.desc_long" v-html="model.desc_long")
                    p(v-else)
                    ul.reports(v-if="model.docs")
                      li(v-for="doc in model.docs" :key="doc.id")
                        a(:href="generic.url" target="new") {{ generic.didascalia }}
        div.navigation
          router-link(v-if="this.$route.params.type === 'drifters'" to="/instruments/floats")
            div
              img(src="../assets/float-tile-instrument.jpg" width="251" height="202")
            div
              h1 instruments
              h2 Floats
              span.arrow
          router-link(v-else to="/instruments/drifters")
            div
              img(src="../assets/drifter-tile-instrument.jpg" width="251" height="202")
            div
              h1 instruments
              h2 Drifters
              span.arrow
          router-link(v-if="this.$route.params.type === 'gliders'" to="/instruments/floats")
            div
              img(src="../assets/float-tile-instrument.jpg" width="251" height="202")
            div
              h1 instruments
              h2 Floats
              span.arrow
          router-link(v-else to="/instruments/gliders")
            div
              img(src="../assets/gliders-tile-instrument.jpg" width="251" height="202")
            div
              h1 instruments
              h2 Gliders
              span.arrow
        div.overlay(:class="{ open: overlay.open }" @click="closeOverlay")
          div.slide
            img(:src="overlay.image" alt="image instrument")
          span.close(@click="closeOverlay") ×
</template>

<script>
import MainMenu from '@/components/MainMenu.vue'
import { mapState } from 'vuex'
import { Carousel, Slide } from 'vue-carousel'
import { vueVimeoPlayer } from 'vue-vimeo-player'

export default {
  name: 'instruments',
  metaInfo: {
    title: 'Instruments'
  },
  components: {
    'main-menu': MainMenu,
    Carousel,
    Slide,
    'vimeo-player': vueVimeoPlayer
  },
  computed: {
    ...mapState({
      settings: 'settings'
    }),
    instrument () {
      return this.$store.state.instruments
    },
    type () {
      return this.$route.params.type === 'drifters' ? 'drifter' : this.$route.params.type === 'floats' ? 'float' : 'glider'
    }
  },
  data () {
    return {
      msg: 'INSTRUMENTS',
      isOpen: false,
      title: this.$route.params.type,
      targets: ['drifters', 'floats', 'gliders'],
      overlay: {
        open: false,
        image: ''
      }
    }
  },
  watch: {
    '$route.params.type': function (type) {
      if (this.targets.includes(type)) {
        this.upData()
      }
    }
  },
  methods: {
    upData () {
      if (this.targets.includes(this.$route.params.type)) {
        this.title = this.$route.params.type
        this.$store.dispatch('LOAD_INSTRUMENTS_LIST', this.$route.params.type)
      } else {
        this.$router.push({ path: '/' })
      }
    },
    openDetails (item) {
      item.open = !item.open
    },
    viewMap (id) {
      this.$store.dispatch('LOAD_INSTRUMENTS_FILTER_LIST', `nationality=ITALY&type=${this.type}`).then(response => {
        this.$store.commit('SET_MAP_FILTERS', {
          type: [this.type],
          instrument: id,
          dateFrom: null,
          dateTo: null,
          nationality: 'ITALY'
        })
        this.$router.push({ path: '/data' })
      })
    },
    openOverlay (slide) {
      this.overlay.open = true
      this.overlay.image = slide.url
    },
    closeOverlay () {
      this.overlay.open = false
    },
    onReadyVideo () {
      console.log('VIMEO ready')
    }
  },
  mounted () {
    this.upData()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .overlay .close {
    top: 3.1em;
  }
</style>



// WEBPACK FOOTER //
// src/views/Instruments.vue